import PropTypes from "prop-types";
import Text from "components/Common/Text";

export function MatchPlayHeader({ holeRemaining, competedMatch }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#2977A4",
        padding: 20,
        maxHeight: 80,
      }}
    >
      <div>
        <Text as="H2" bold>
          {competedMatch ? "Completed match" : "Holes Remaining"}
        </Text>
      </div>
      {!competedMatch && (
        <div>
          <Text
            style={{
              padding: "4px 31px",
              backgroundColor: "white",
              borderRadius: 8,
              color: "black",
            }}
            as="H1"
            bold
          >
            {holeRemaining}
          </Text>
        </div>
      )}
    </div>
  );
}

MatchPlayHeader.propTypes = {
  holeRemaining: PropTypes.number,
  competedMatch: PropTypes.bool,
};

MatchPlayHeader.defaultProps = {
  holeRemaining: 0,
  competedMatch: false,
};
